import { render, staticRenderFns } from "./ClientAccountActions.vue?vue&type=template&id=90dc8196&scoped=true&"
import script from "./ClientAccountActions.vue?vue&type=script&lang=js&"
export * from "./ClientAccountActions.vue?vue&type=script&lang=js&"
import style0 from "./ClientAccountActions.vue?vue&type=style&index=0&id=90dc8196&prod&lang=scss&"
import style1 from "./ClientAccountActions.vue?vue&type=style&index=1&id=90dc8196&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90dc8196",
  null
  
)

export default component.exports